import React, { Fragment } from 'react';
import { formatCurrency } from '../../utils/format';

const Coupon = ({ coupon, removeCoupon }) => {
    const couponCode = (
        <span>
            {coupon.couponCode}
            {coupon.couponPercentage ? <span className='coupon-badge'>{`${app_main_wpml.discount} ${coupon.couponPercentage}%`}</span> : ''}
        </span>
    );
    return (
        <Fragment>
            <div className="meta">
                <div className="meta__key">
                    <h6 className="meta__key__title" style={{ marginBottom: '8px' }}>{coupon.isGiftcard ? app_main_wpml.gift_card : app_main_wpml.coupon}</h6>
                    <a onClick={() => removeCoupon(coupon.couponCode)} className="meta__key__remove">
                        {app_main_wpml.remove}
                    </a>
                </div>
                <div className="meta__value">
                    <p className="meta__value__text">
                        {coupon.isGiftcard ? coupon.couponCode.match(/.{1,4}/g).join(" ") : couponCode}
                        {coupon.isGiftcard && (<Fragment>
                            <span className="is-gray"><br />{app_main_wpml.remainingAmount} {formatCurrency(coupon.couponRemaining)}</span>
                        </Fragment>)}
                    </p>
                    <p className="meta__value__amount">
                        -{formatCurrency(coupon.couponValue)}
                    </p>
                </div>
            </div>
        </Fragment>
    );
};

export default Coupon;
